const header = document.querySelector('.hs-site-header');
const progressBar = document.querySelector('#progress-bar');
const demoVideo = document.querySelector('#demo-video');
const videoFrame = document.querySelector('.hs-video-frame');
const soundToggle = document.querySelector('#sound-toggle');
const soundLabel = document.querySelector('#sound-label');
const videoRuntime = document.querySelector('#video-runtime');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const updatePageChrome = () => {
  const scrollTop = window.scrollY;
  const scrollable = document.documentElement.scrollHeight - window.innerHeight;
  const progress = scrollable > 0 ? Math.min(scrollTop / scrollable, 1) : 0;

  header.classList.toggle('hs-is-scrolled', scrollTop > 24);
  progressBar.style.width = `${progress * 100}%`;
};

const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('hs-is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.12 }
);

document.querySelectorAll('.hs-reveal').forEach((element) => revealObserver.observe(element));

const syncVideoState = () => {
  videoFrame.classList.toggle('hs-is-playing', !demoVideo.paused);
  soundToggle.setAttribute('aria-pressed', String(!demoVideo.muted));
  soundLabel.textContent = demoVideo.muted ? 'Turn sound on' : 'Mute video';
};

const syncVideoRuntime = () => {
  if (!Number.isFinite(demoVideo.duration)) return;

  const minutes = Math.floor(demoVideo.duration / 60);
  const seconds = Math.floor(demoVideo.duration % 60);
  const runtime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  const description = demoVideo.duration > 30 ? 'complete demonstration' : 'quick demonstration';

  videoRuntime.textContent = `Auto-playing · ${runtime} ${description}`;
};

soundToggle.addEventListener('click', () => {
  demoVideo.muted = !demoVideo.muted;
  if (demoVideo.paused) demoVideo.play().catch(() => {});
  syncVideoState();
});

demoVideo.addEventListener('play', syncVideoState);
demoVideo.addEventListener('pause', syncVideoState);
demoVideo.addEventListener('volumechange', syncVideoState);
demoVideo.addEventListener('loadedmetadata', syncVideoRuntime);
if (demoVideo.readyState >= 1) syncVideoRuntime();

const videoObserver = new IntersectionObserver(
  ([entry]) => {
    if (reduceMotion.matches) {
      demoVideo.pause();
      return;
    }

    if (entry.isIntersecting) {
      demoVideo.play().catch(() => {});
    } else {
      demoVideo.pause();
    }
  },
  { threshold: 0.35 }
);

videoObserver.observe(demoVideo);
syncVideoState();
window.addEventListener('scroll', updatePageChrome, { passive: true });
updatePageChrome();

